import { southernServicesLandfillData } from "constants-lib/seo/southernServicesLandfillData"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const getSouthernServicesLandfill = () => {
  const data = southernServicesLandfillData.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addSouthernServicesLandfillJSONLD = () => {
  if (
    window.location.href.includes(`/us/en/southern-services-landfill/faq`) &&
    document.getElementById(`southernServicesLandfillJSONLD`) === null
  ) {
    const script = southernServicesLandfillJSONLD()
    addJSONLDToHead(script, `southernServicesLandfillJSONLD`)
  } else {
    removeElement(`southernServicesLandfillJSONLD`)
  }
}

// JSON LD template for FAQ Bagster
const southernServicesLandfillJSONLD = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getSouthernServicesLandfill(),
  }
  return FaqBagsterTemplate
}
